module.exports = {"loadingText":"Načítám konfigurační data pro modul Report"}